import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Pageable } from './pageable';
import { VehicleService } from 'src/app/vehicles/vehicle.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css'],
    standalone: false
})
export class PaginationComponent implements OnChanges {
  
  @Input() pageable!: Pageable;
  @Input() status!: string;
  @Input() size!: number;
  
  @Output() navigateToPage: EventEmitter<number> = new EventEmitter<number>();

  constructor(private vehicleService: VehicleService, private router: Router) {}

  pageTotal: number = 0;
  pageSize: number = 0;

  isFirstPage: boolean = false;
  isLastPage: boolean = false;
  previousPage: number = 0;
  nextPage: number = 0;
  currentPage: number = 0;

  statusFilter: string = 'dfdf';
  sortBy: string = '';

  previousButton: string = 'page-link';
  nextButton: string = 'page-link';

  errorMessage: string = '';

  navigatePreviousPage(): void {
    this.navigateToPage.emit(this.previousPage);
  }

  navigateNextPage(): void {
    this.navigateToPage.emit(this.nextPage);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('pagination component changes', changes);

    if(this.pageable !== undefined) {
      this.pageTotal = changes['pageable'].currentValue.totalPages;
      this.currentPage = changes['pageable'].currentValue.currentPage;
      this.isFirstPage = changes['pageable'].currentValue.firstPage;
      this.isLastPage = changes['pageable'].currentValue.lastPage;

      if(this.currentPage > 0) {
        this.previousPage = Number(this.currentPage) - 1;
      }
      if(this.currentPage <= this.pageTotal) {
        this.nextPage = Number(this.currentPage) + 1;
      }

      this.previousButton = 'page-link';
      this.nextButton = 'page-link';
      if(this.isFirstPage) {
        this.previousButton = 'page-link disabled';
      }
      if(this.isLastPage) {
        this.nextButton = 'page-link disabled';
      }
    }
}

  ngOnInit(): void {
    if(this.pageable !== undefined) {
      console.log('Page Object', this.pageable);
      this.pageTotal = this.pageable.totalPages;
      this.currentPage = this.pageable.currentPage;
    }
  }
}
